// import react from "react";

const MODAL_SIZE_CLASS_MAP = {
    sm: "modal-sm",
    lg: "modal-lg",
    xl: "modal-xl",
    wide: "modal-job-details-wide",
};

export default function ModalForm({ title, onClose, children, footer, size = "md" }) {
    const modalSizeClass = MODAL_SIZE_CLASS_MAP[size] || "";

    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            onClose?.();
        }
    };
    
    return (
        <div
            className="modal fade show oplm-modal"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            onClick={handleBackdropClick}
        >
            <div className={`modal-dialog modal-dialog-centered ${modalSizeClass}`} role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={onClose}
                        />
                    </div>
                    <div className="modal-body">{children}</div>
                    {footer && (
                        <div className="modal-footer">
                            {footer}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export { ModalForm };